import { v4 as uuidv4 } from "uuid";

import { navigate } from "@gatsbyjs/reach-router";

import API from "../utils/api";

const moment = require("moment");

// Set window title
export const setWindowTitle = (title: string) => {
  let defaultTitle = "Sensor Admin";

  if (title !== undefined && title !== null && title !== "") {
    defaultTitle = defaultTitle + " - " + title;
  }

  document.title = defaultTitle;
};

// Change case
export const changeCase = (val: string, type: string) => {
  if (type.toLowerCase() === "l") {
    return val.toUpperCase();
  } else if (type.toLowerCase() === "u") {
    return val.toUpperCase();
  }

  return val;
};

export const isMobile = () => {
  const { innerWidth: width } = window;
  return width <= 600 ? true : false;
};

// Check the string is json format or not
export const isValidJSONString = (jsonString: string) => {
  try {
    const o = JSON.parse(JSON.stringify(jsonString));
    if (o && typeof o === "object") {
      return true;
    }
  } catch (error) { }
  return false;
};

export const getBreadcrumbMaxItems = (maxitem: number) => {
  if (isMobile()) {
    return maxitem;
  }
  return 100;
};

// Few json boolean values are in string format ("true") instead of boolean value (true)
// using this to function convert the boolean string format to boolean
export const convertStringToBoolean = (value: any) => {
  let returnValue = false;

  if (value !== undefined || value != null) {
    if (typeof value === "string") {
      if (String(value) === "true") {
        returnValue = true;
      }
    } else if (typeof value === "boolean") {
      returnValue = value;
    }
  }
  return returnValue;
};

export const generateUUID = () => {
  const newId: string = uuidv4();
  return newId.replaceAll("-", "");
};

// Get datagrid rows per page dropdown option values
export const getDatagridRowsPerPageOptions = () => {
  const datagridRowsPerPageOptions = [5, 10, 15, 20, 25, 50, 75, 100];
  return datagridRowsPerPageOptions;
};

// Redirect route page
export const redirectRoutePage = (routename: string) => {
  routename = "redirectPage/" + encodeURIComponent(routename);
  navigate("/" + routename, { replace: true });
};

// Go to route
export const goToRoutePage = (routename: string) => {
  const currentURL = window.location.pathname;

  let replaceEditPage = false;

  try {
    const replaceKeyWords = ["clientcompanies/", "programs/", "kits/"];

    replaceKeyWords.forEach((keyword) => {
      if (currentURL.indexOf(keyword) > 0) {
        replaceEditPage = true;
        return;
      }
    });
  } catch (e) { }

  if (replaceEditPage || routename === "login") {
    redirectRoutePage(routename);
  } else {
    navigate("/" + routename, { replace: false });
  }
};

// Open external link (new tab)
export const openExternalLink = (url: string) => {
  openExternalLinkWithTarget(url, "_blank");
};

export const openExternalLinkWithTarget = (url: string, targetName: string) => {
  window.open(url, targetName);
};

// Checking formik is valid or not
export const isFormReferenceValid = (formReference: any) => {
  let valid = false;
  try {
    if (formReference !== null || formReference !== undefined || formReference !== "") {
      if (formReference !== undefined && formReference.current !== null) {
        valid = true;
      }
    }
  } catch (e) { }
  return valid;
};

// Checking formik data is valid or not
export const isFormDataValid = (formReference: any) => {
  let valid = false;

  try {
    if (isFormReferenceValid(formReference)) {
      if (formReference.current.isValid) {
        valid = true;
      }
    }
  } catch (e) { }
  return valid;
};



// set form field touch indicator true and turn validation on
export const setAllFieldTouched = (formReference: any, parentName: string, jsonData: any) => {
  if (isFormReferenceValid(formReference)) {
    for (const key in jsonData) {
      if (typeof jsonData[key] !== "object") {
        if (parentName !== "") {
          formReference.current.setFieldTouched(parentName + "." + key, true, true);
        } else {
          formReference.current.setFieldTouched(key, true, true);
        }
      } else {
        if (parentName !== "") {
          setAllFieldTouched(formReference, parentName + "." + key, jsonData[key]);
        } else {
          setAllFieldTouched(formReference, key, jsonData[key]);
        }
      }
    }
  }
};

// Handling api error on request
export const apiRequestError = (e: any, customErrorDescription: string) => {
  if (e !== undefined && e !== null) {
    if (!window.navigator.onLine) {
      return "There is no internet connection. Please check your network.";
    } else if (e.response?.data.status === 401 && e.response?.data.status === "unauthorized") {
      return e.response?.data.detail;
    }
  }
  return customErrorDescription;
};

// Handling api error on response
export const apiReponseError = (error: any, customErrorDescription: string) => {
  if (error !== undefined && error !== null) {
    if (error?.response?.status === 503) {
      var message503 = error.response.data.message;
      if (message503 !== "" && message503 !== null && message503 !== undefined) {
        return message503;
      }
      return "The Server encountered an error and could not complete your request (Http Code 500).";
    } else if (error?.response?.status >= 500) {
      return "The Server encountered an error and could not complete your request (Http Code 500).";
    } else if (error?.response?.status === 404) {
      let errorMessage = error.response.data.message;
      if (errorMessage === null || errorMessage === undefined || errorMessage === "") {
        errorMessage = "Something was wrong in our system.";
      }
      return errorMessage;
    } else if (error?.response?.status === 401) {
      let errorDetail = error.response?.data.detail;
      if (errorDetail !== undefined && errorDetail !== "" && errorDetail !== null && errorDetail.length > 50) {
        return errorDetail + ".";
      }
      errorDetail = error?.response?.data?.message;
      if (errorDetail !== undefined && errorDetail !== "" && errorDetail !== null) {
        return errorDetail;
      }
    } else if (error?.response?.status === 403) {
      let errorMessage = error.response.data.message;

      if (errorMessage === null || errorMessage === undefined || errorMessage === "") {
        errorMessage = "Access Forbidden";
      }
      return errorMessage;
    } else if (error?.response?.status === 400) {
      const errorDetail = error.response?.data.message;
      const errorTitle = error.response?.data.title;

      if (errorTitle !== "" && errorTitle !== null && errorTitle !== undefined) {
        return errorTitle;
      }

      if (errorDetail !== "" && errorDetail !== null && errorDetail !== undefined) {
        return errorDetail;
      }
    }
  }
  return customErrorDescription;
};

// Checking user is authenticated,  if not redirect to login screen
export const checkUserAuthenticated = (isUserAuthenticated: boolean) => {
  if (!isUserAuthenticated) {
    navigate("/login");
  }
};

// Clear local storage all or selected item
export const clearLocalStorage = (name: string, refreshPage: boolean) => {
  const excludeNames = ["themetype", "authtoken", "MainMenuContentVisible"];
  if (name === null || name === undefined) {
    return;
  }

  for (let i = 0; i < localStorage.length; i++) {
    const localStorageKeyName = localStorage.key(i);

    if (localStorageKeyName !== null && localStorageKeyName !== undefined) {
      if (localStorageKeyName.toLowerCase() === name.toLowerCase()) {
        localStorage.removeItem(localStorageKeyName);
        break;
      } else if (name === "") {
        if (excludeNames.indexOf(localStorageKeyName.toLowerCase()) === -1) {
          localStorage.removeItem(localStorageKeyName);
          i = 0;
        }
      }
    }
  }

  if (name === "" && refreshPage) {
    goToRoutePage("Home");
  }
};

// Clear session storage all or selected item
export const clearSessionStorage = () => {
  const excludeNames = ["sessionauthtoken"];

  for (let i = 0; i < sessionStorage.length; i++) {
    const sessionStorageKeyName = sessionStorage.key(i);

    if (sessionStorageKeyName !== null && sessionStorageKeyName !== undefined) {
      if (excludeNames.indexOf(sessionStorageKeyName.toLowerCase()) === -1) {
        sessionStorage.removeItem(sessionStorageKeyName);
        i = 0;
      }
    }
  }
};

// Selected Page sub paths
export const getAppRoutePagePaths = (pagename: string, appRoutes: AppRoutePath[]): AppPagePath[] => {
  const paths = appRoutes.filter((route) => route.title === pagename);
  if (paths.length > 0) {
    return paths[0].paths;
  }
  return [];
};

// Return default address result object
export const getDefaultAddressResult = () => {
  return {
    valid: false,
    message: "Something was wrong in our system.",
    address: { addressline1: "", addressline2: "", addressline3: "", country: "", locality1: "", locality2: "", postalCode: "", postalCodeFull: "", region1: "", region2: "" },
    addressLine: "",
    cityStatePostalCountry: "",
    errorCodeTagged: false,
    latitude: 0,
    longitude: 0,
    poBox: false,
    autoCorrect: false,
    sameAddressLine: false,
    addressType: "",
    show: false,
    skip: false,
  } as AddressResultOutput;
};

// Address Validation
export const addressValidation = async (payload: any): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  payload.address.addressline1 = payload.address.addressline1.trim();
  payload.address.addressline2 = payload.address.addressline2.trim();
  payload.address.addressline3 = payload.address.addressline3.trim();
  payload.address.locality1 = payload.address.locality1.trim();
  payload.address.locality2 = payload.address.locality2.trim();
  payload.address.region1 = payload.address.region1.trim();
  payload.address.region2 = payload.address.region2.trim();
  payload.address.postalCode = payload.address.postalCode.trim();
  payload.address.country = payload.address.country.trim();

  try {
    await API.post("/api/validation/address", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            address: response.data.address,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid address.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get client company detail
export const getClientCompanyDetail = async (clientCompanyKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/clientcompanies/" + clientCompanyKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            clientCompany: response.data?.clientCompany,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid client company key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get site setting
export const getSiteSetting = async (): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/admin/sitesetting")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            siteSetting: response.data?.siteSetting as SiteSetting,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Site setting missing.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }
  return apiResponse;
};

// Toggle show dashboard value and save to local storage
export const toggleShowDashboard = (localStorageName, currentValue) => {
  var tempCurrentValue = !currentValue;

  if (tempCurrentValue) {
    window.localStorage.setItem(localStorageName, "1");
  }
  else {
    window.localStorage.setItem(localStorageName, "0");
  }

  return tempCurrentValue;
}

// Get show dashboard value from local storage
export const getShowDashboardValue = (localStorageName, defaultValue) => {

  try {
    var val = window.localStorage.getItem(localStorageName);

    if (val === "1") {
      return true;
    }
    else if (val === "0") {
      return false;
    }
  }
  catch { }

  return defaultValue;
}

export const getUserDetail = async (email: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    const payload = {
      email: email
    }

    await API.post("/api/admin/users/user/checkemail", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            user: response.data?.user,
            roleName: response.data?.roleName
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid user email.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get admin user detail
export const getAdminUserDetail = async (userKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/admin/users/" + userKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            adminUser: response.data?.adminUser,
            roles: response.data?.roles,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid user key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get admin api keys
export const getClientApiKeys = async (): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/admin/clientapikeys/")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            clientApiKeys: response.data?.clientApiKeys as ClientApiKey[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load api keys.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get admin api key attributes
export const getClientApiKey = async (apiKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/admin/clientapikeys/" + apiKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            clientApiKey: response.data?.clientApiKey as ClientApiKey,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load api key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get program detail
export const getProgramDetail = async (programKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/programs/" + programKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            program: response.data?.program,
            folder: response.data?.folder,
            programKits: response.data?.programKits,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid program key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get program other attribute
export const getProgramOtherAttributes = async (programKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/programs/" + programKey + "/other/attributes")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            programOtherAttribute: response.data?.programOtherAttribute as ProgramOtherAttribute,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid program key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get program other attribute
export const getProgramLegacyEnlistmentContents = async (programKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/programs/" + programKey + "/other/legacyenlistmentcontents")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            legacyEnlistmentContents: response.data?.legacyEnlistmentContents as LegacyEnlistmentContent[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid program key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get program detail
export const getProgramView = async (programKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/programs/" + programKey + "/view")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            onboardingProgram: response.data?.onboardingProgram as OnboardingProgram,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid program key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get kit detail
export const getKitDetail = async (kitKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/kits/" + kitKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            kit: response.data?.kit,
            associations: response.data?.associations,
            kitItems: response.data?.kitItems,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid kit key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get sku detail
export const getSKUDetail = async (skuKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/skus/" + skuKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            sku: response.data?.sku,
            associatedKits: response.data?.associatedKits,
            associatedEntities: response.data?.associatedEntities,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load sku detail.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get sku detail
export const getKitItemDetail = async (kitKey: string, kitItemKey): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/kits/" + kitKey + "/kititems/" + kitItemKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            kitItem: response.data?.kitItem,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load kit item detail.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get esp job logs
export const getESPJobLogs = async (espJobName: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/espjobs/" + espJobName + "/logs")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          const rows: any = [];
          response.data.espjoblogs.map((espjoblog, index) =>
            rows.push({
              id: index,
              ...espjoblog,
            })
          );

          apiResponse.data = {
            espjoblogs: rows,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load esp job status.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get esp job log detail
export const getESPJobLogDetail = async (espJobName: string, fileKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    fileKey = encodeURIComponent(fileKey);
    await API.get("/api/espjobs/" + espJobName + "/logs/content?fileKey=" + fileKey).then(async (response) => {
      apiResponse.data = {
        content: response.data.content,
      };
      apiResponse.success = true;
      apiResponse.errorMessage = "";
    });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get esp job status
export const getESPJobStatus = async (espJobKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/espjobs/" + espJobKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            espJob: response.data?.espJob,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load esp job status.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Trigger preenroll job
export const triggerPreEnroll = async (): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/enrollment/batch/files/trigger")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = "";
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to trigger job.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Trigger esp job status
export const triggerESPJobs = async (espJobKey: string, referenceId: number): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    let url = "/api/espjobs/" + espJobKey + "/trigger";

    if (referenceId > 0) {
      url = url + "/" + referenceId;
    }

    await API.post(url, "")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            status: response.data?.status,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to trigger esp job.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

export const getPendingEnrollmentCompanyBatches = async (companyKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/pendingenrollment/companies/" + companyKey + "/batches")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          const rows: any = [];
          response.data.pendingCompanyBatches.map((pendingCompanyBatch, index) =>
            rows.push({
              id: index,
              ...pendingCompanyBatch,
            })
          );

          apiResponse.data = {
            pendingEnrollmentCompanyBatches: rows as PendingEnrollmentCompanyBatch[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load pending enrollment batches.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get pending enrollment file items
export const getPreEnrollBatchPendingFileItems = async (preBatchLoadKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/enrollment/batch/files/" + preBatchLoadKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          const rows: any = [];
          response.data.preEnrollBatchPendingFileItems.map((preEnrollBatchPendingFileItem, index) =>
            rows.push({
              id: index,
              ...preEnrollBatchPendingFileItem,
            })
          );

          apiResponse.data = {
            preEnrollBatchPendingFileItems: rows as PreEnrollBatchPendingFileItem[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load pending enrollment file items.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something went wrong in our system.");
  }

  return apiResponse;
};

// Get pending enrollment company batch items
export const getPendingEnrollmentCompanyBatchItems = async (companyKey: string, batchLoadKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/pendingenrollment/companies/" + companyKey + "/batches/" + batchLoadKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          const rows: any = [];
          response.data.pendingCompanyBatchItems.map((pendingCompanyBatchItem, index) =>
            rows.push({
              id: index,
              ...pendingCompanyBatchItem,
              ...pendingCompanyBatchItem.address,
            })
          );

          apiResponse.data = {
            pendingEnrollmentCompanyBatchItems: rows as PendingEnrollmentCompanyBatchItem[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load pending enrollment batch items.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something went wrong in our system.");
  }

  return apiResponse;
};

// Get sku association entities
export const getSKUAssociateEntities = async (skuKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/skus/" + skuKey + "/associate/entities")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            associatedEntities: response.data?.associatedEntities,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load sku associate entities.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get enlistment program locations
export const getEnlistmentProgramLocations = async (partnerKey: string, programKey: string, status: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/enlistmentadmin/partners/" + partnerKey + "/programs/" + programKey + "/" + status + "/locations")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            locations: response.data?.locations as EnlistmentReviewAccount[],
            programStatusDashboard: response.data?.programStatusDashboard as ProgramStatusDashboard[],
            programEnrollmentDashboard: response.data?.programEnrollmentDashboard as ProgramEnrollmentDashboard[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid kit key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get enlistment program location
export const getEnlistmentProgramLocation = async (partnerKey: string, programKey: string, locationItemKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/enlistmentadmin/partners/" + partnerKey + "/programs/" + programKey + "/Locations/" + locationItemKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            location: response.data?.location as EnlistmentReviewAccount,
            locationKits: response.data?.kits as LocationKit[],
            programs: response.data?.programs as EnlistmentChangeProgram[],
            orderCancelReasons: response.data?.orderCancelReasons as EnlistmentOrderCancelReason[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid location item key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get enlistment program location
export const downloadEnlistmentProgramLocationTaxExemptFile = async (locationItemKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/enlistmentadmin/Locations/" + locationItemKey + "/download/taxexexemptfile")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            content: response.data?.content,
            fileName: response.data?.fileName,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid location item key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

//Get pending enrollment batch item
export const getPendingEnrollmentBatchItem = async (batchLoadItemKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/pendingenrollment/batch/" + batchLoadItemKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            pendingEnrollmentBatchLoadItem: response.data?.pendingEnrollmentBatchLoadItem as PendingEnrollmentBatchLoadItem,
            pendingEnrollmentBatchLoadItemLogs: response.data?.pendingEnrollmentBatchLoadItemLogs as PendingEnrollmentBatchLoadItemLog[],
            kits: response.data?.locationKits as LocationKit[],
            programs: response.data?.programs as PendingEnrollmentBatchLoadItemProgram[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid batch load item key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

//Get saves entities
export const getSavesEntities = async (): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/saves/entities")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            savesEntities: response.data?.savesEntities as SavesEntity[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid saves entities.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

//Get saves entity values
export const getSavesEntityValues = async (saveEntityKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/saves/entities/" + saveEntityKey + "/values")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            savesEntityValues: response.data?.savesEntityValues as SavesEntityValue[],
            savesEntityValueExpirationSummaries: response.data?.savesEntityValueExpirationSummaries as SavesEntityValueExpirationSummary[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid saves entity key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

//Get saves entity values
export const getSavesEntityValue = async (saveEntityKey: string, saveEntityValueKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/saves/entities/" + saveEntityKey + "/values/" + saveEntityValueKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            savesEntityValue: response.data?.savesEntityValue as SavesEntityValue,
            countries: response.data?.countries as Country[],
            savesTypes: response.data?.savesTypes as SavesType[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid saves entity value key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get enlistment parent search
export const getEnlistmentParentAccountSearch = async (locationItemKey: string, searchText: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    const payload = {
      locationItemKey: locationItemKey,
      searchText: searchText
    }

    await API.post("/api/enlistmentadmin/parentaccount/search", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            parentAccounts: response.data?.parentAccounts,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load parent accounts.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get enlistment parent search
export const getContractOrderAccountTree = async (programCode: string, accountNumber: string, refreshCache: boolean): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    const payload = {
      programCode: programCode,
      accountNumber: accountNumber,
      refreshCache: refreshCache
    }

    await API.post("/api/contractorders/accounttree", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            nodes: response.data?.nodes,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load account tree data.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get enlistment parent search
export const getContractOrderAccountSearch = async (programKey: string, searchText: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    const payload = {
      programKey: programKey,
      searchText: searchText
    }

    await API.post("/api/contractorders/accountsearch", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            accounts: response.data?.accounts,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load program accounts.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

//Get contract orders
export const getContractOrders = async (): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/contractOrders")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            contractOrders: response.data?.contractOrders as ContractOrder[],
            issueSummaries: response.data?.issueSummaries as ContractOrderIssueSummaryItem[],
            preOrderStatusSummaries: response.data?.statusSummaries as TitleCountSummaryItem[],
            lookupValues: response.data?.lookupValues as ContractOrderLookupValues
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid contract orders.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

//Get contract order
export const getContractOrder = async (contractOrderKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/contractorders/" + contractOrderKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            contractOrder: response.data?.contractOrder as ContractOrder,
            lookupValues: response.data?.lookupValues as ContractOrderLookupValues,
            preOrderSummary: response.data?.preOrderSummary as TitleCountSummaryItem[]
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid contract order key.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Generate QR code
export const generateQRCode = async (text: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/generate/qrcode/" + text)
      .then(async (response) => {
        apiResponse.data = {
          qrcodeBase64String: response.data,
        };
        apiResponse.success = true;
        apiResponse.errorMessage = "";
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load sku associate entities.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

export const validateEmail = async (email: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  const payload = {
    email: email,
  };

  try {
    await API.post("/api/validation/emaildomain", payload)
      .then(async (response) => {
        apiResponse.data = {
          emailValidationResult: response.data as EmailValidationResult,
        };
        apiResponse.success = true;
        apiResponse.errorMessage = "";
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to validate email.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

export const validatePhone = async (phone: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  const payload = {};

  try {
    await API.post("/api/validation/phoneinfo/" + phone, payload)
      .then(async (response) => {
        apiResponse.data = {
          phoneValidationResult: response.data,
        };
        apiResponse.success = true;
        apiResponse.errorMessage = "";
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to validate phone.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Clear server cache
export const clearServerCache = async (): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/clearCache")
      .then(async (response) => {
        apiResponse.data = {};
        apiResponse.success = true;
        apiResponse.errorMessage = "";
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Failed to load sku associate entities.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Get subscription list
export const getSubscriptionList = async (clientCompanyKey: string, programKey: string, state: string, status: number, searchText: string): Promise<ApiResponse> => {
  const payload = {
    clientCompanyKey,
    programKey,
    state,
    status,
    searchText,
  };

  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.post("/api/subscription/search", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            subscriptions: response.data?.subscriptions as Subscription[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Order folder search
export const orderFolderSearch = async (searchText: string): Promise<ApiResponse> => {
  const payload = {
    searchText,
  };

  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.post("/api/orders/folder/search", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            orderFolderSearchItems: response.data?.orderFolderSearchItems as OrderFolderSearchItem[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Order folder detail
export const orderDetail = async (orderKey: string, folderId: number): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get(orderKey !== "" ? "/api/orders/" + orderKey : "/api/orders/new/" + folderId.toString())
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            order: response.data?.order,
            folder: response.data?.folder,
            shipping: response.data?.shipping,
            chargeableTypes: response.data?.lookups?.chargeableTypes,
            deviceOwnerships: response.data?.lookups?.deviceOwnerships,
            orderTypes: response.data?.lookups?.orderTypes,
            fulfillmentVendors: response.data?.lookups?.fulfillmentVendors,
            platformVendors: response.data?.lookups?.platformVendors,
            programSKUs: response.data?.programSKUs as OrderProgramSku[],
            ProgramKits: response.data?.kits as OrderProgramKit[],
            crmCases: response.data?.crmCases as CrmCase[],
            contracts: response.data?.contracts as Contract[],
            orderItems: response.data?.orderItems as OrderProgramSku[],
          } as NewOrder;
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Order folder detail
export const orderContractOrderDetail = async (contractOrderKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/orders/contractorders/" + contractOrderKey)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            contractOrder: response.data?.contractOrder as ContractOrder
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};


export const orderProgramContractOrders = async (programKey: string, chargeableTypeId: number): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/orders/contractorders/" + programKey + "/" + chargeableTypeId)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            contracts: response.data?.contracts as ContractOrder[]
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Order summaries
export const orderSummaries = async (): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/orders/summaries")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            orderSummaries: response.data as OrderSummaries
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

export const getAccountOptouts = async ( ): Promise<ApiResponse> => {

  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/accountoptouts")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            accountOptoutItems: response.data?.accountOptoutItems as AccountOptoutItem[],
            companies: response.data?.companies as AccountOptoutCompany[]
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};


// Get replacement order list
export const getReplacementOrderList = async (orderTypeId: number, processDate: any): Promise<ApiResponse> => {
  const payload = {
    orderTypeId,
    processDate,
  };

  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.post("/api/replacement/order/search", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            replacementOrders: response.data?.replacementOrders as ReplacementOrder[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Search parent account list
export const parentAccountSearchList = async (programCode: string, searchText: string): Promise<ApiResponse> => {
  const payload = {
    programCode,
    searchText,
  };

  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.post("/api/onboarding/program/parentaccount/search", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            parentAccounts: response.data?.parentAccounts as parentAccountSearchItem[],
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Search parent account list
export const getClientApiKeyUserDetail = async (clientCompanyKey: string): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/onboarding/clientcompanies/" + clientCompanyKey + "/apikey")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            clientApiKeyUser: response.data as ClientApiKeyUser,
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Invalid params.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// User assigned programs
export const getUserAssignedPrograms = async (): Promise<ApiResponse> => {
  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.get("/api/admin/user/assigned/programs")
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = {
            userAssignedPrograms: response.data.userAssignedPrograms as UserAssignedProgram[]
          };
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorMessage = apiReponseError(error, "Unable get user assigned programs.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Upload status batch file
export const uploadStatusBatchFile = async (fileHandle: any): Promise<ApiResponse> => {
  const payload = new FormData();
  payload.append("file", fileHandle);

  const apiResponse: ApiResponse = {
    success: false,
    data: null,
    errorObject: [],
    errorMessage: "Something was wrong in our system.",
  };

  try {
    await API.postfile("/api/enrollment/batch/file", payload)
      .then(async (response) => {
        if (isValidJSONString(response.data)) {
          apiResponse.data = response.data;
          apiResponse.success = true;
          apiResponse.errorMessage = "";
        }
      })
      .catch((error) => {
        apiResponse.errorObject = getErrorObject(error, "");
        apiResponse.errorMessage = apiReponseError(error, "Unable to upload file.");
      });
  } catch (e) {
    apiResponse.errorMessage = apiRequestError(e, "Something was wrong in our system.");
  }

  return apiResponse;
};

// Return error list from api response error object
export const getErrorObject = (apiError: any, replacePrefix: string) => {
  const errorList: ApiResponseErrorObject[] = [];
  try {
    Object.keys(apiError.response.data.errors).forEach((key) => {
      errorList.push({ title: key.replaceAll(replacePrefix, ""), message: apiError.response.data.errors[key] });
    });
  } catch (e) { }

  return errorList;
};

export const a11yTabProps = (prefix: any) => {
  return {
    id: `scrollable-auto-tab-${prefix}`,
    "aria-controls": `scrollable-auto-tabpanel-${prefix}`,
  };
};

// Checking string for null, whitespace & undefined
export const isNullOrWhiteSpace = (str: string) => {
  return str === null || str === undefined || str.replace(/\s/g, "").length < 1;
};

//Return country and state codes
export const filterCountryStates = (countries: Country[], countryCode: string): State[] => {
  if (countryCode === "US") {
    countryCode = "USA";
  } else if (countryCode === "CA") {
    countryCode = "CAN";
  }
  const country = countries.filter((country) => country.code === countryCode);
  if (country.length) {
    return country[0].states;
  }
  return [];
};

// Sort array objects
export const compareArrayObjectValue = (key: string, order: "asc" | "desc" | undefined) => {
  if (order === undefined) {
    order = "asc";
  }

  return function innerSort(a: any, b: any) {
    // property doesn't exist on either object
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
};

// Convert bolean to text 'yes' or 'no'
export const convertBoolenStringToString = (val: string) => {
  if (val === "true") {
    return "True";
  }
  return "False";
};

// Convert bolean to text 'yes' or 'no'
export const convertBoolenToString = (val: boolean) => {
  if (val === true) {
    return "True";
  }
  return "False";
};


export const getMomentDate = (key: 'years' | 'quarters' | 'months' | 'weeks' | 'days' | 'hours' | 'minutes' | 'seconds' | 'milliseconds', val: number) => {
  return moment().add(val, 'days').format("MM/DD/YYYY");
};

// Format date for datagrid
export const formatDateForDataGrid = (val: string) => {
  try {
    if (val !== "" && val !== null && val !== undefined) {
      const formattedDateTime = moment(val).format("MM/DD/YYYY");
      if (formattedDateTime !== null || formattedDateTime !== "" || formattedDateTime !== "Invalid date" || formattedDateTime !== "01/01/0001") {
        return formattedDateTime;
      }
    }
  } catch (e) { }

  return "";
};

// Format date for input
export const formatDateForInput = (val: string) => {
  try {
    if (val !== "" && val !== null && val !== undefined) {
      const formattedDateTime = moment(val).format("YYYY-MM-DD");
      if (formattedDateTime !== null || formattedDateTime !== "" || formattedDateTime !== "Invalid date" || formattedDateTime !== "01/01/0001") {
        return formattedDateTime;
      }
    }
  } catch (e) { }

  return "";
};

export const formatDateTimeForDataGrid = (val: string) => {
  try {
    if (val !== "" && val !== null && val !== undefined) {
      const formattedDateTime = moment(val).format("MM/DD/YYYY h:mm:ss a");
      if (formattedDateTime !== null || formattedDateTime !== "" || formattedDateTime !== "Invalid date") {
        return formattedDateTime;
      }
    }
  } catch (e) { }
  return "";
};

// Convert number(1/0) to text 'yes' or 'no'
export const convertNumberToYesNo = (val: number) => {
  if (val === 1) {
    return "Yes";
  }
  return "No";
};

export const copyToClipboard = (copiedText: string) => {
  navigator.clipboard.writeText(copiedText);
};

// Trim all attributes in the json data
export const trimAllValues = (jsonData) => {
  try {
    for (const key in jsonData) {
      if (typeof jsonData[key] === "string") {
        jsonData[key] = jsonData[key].trim();
      } else if (typeof jsonData[key] === "object") {
        trimAllValues(jsonData[key]);
      }
    }
  } catch (e) { }
  return jsonData;
};

//User Access
//------------------------------

export const isITTeam = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.iTTeam) {
    return true;
  }
  return false;
};

// Can approve data
export const canApprove = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.onboardingKitApprover) {
    return true;
  }
  return false;
};

// Can have client company read access
export const canReadCompany = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.onboardingCompanyAdminRead || userFunctionAccess.onboardingCompanyAdminWrite) {
    return true;
  }
  return false;
};

// Can have client company write access
export const canWriteCompany = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.onboardingCompanyAdminWrite) {
    return true;
  }
  return false;
};

// Can have program read access
export const canReadProgram = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.onboardingProgramAdminRead || userFunctionAccess.onboardingProgramAdminWrite) {
    return true;
  }
  return false;
};

// Can have user write access
export const canWriteUser = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.userPermissionAdmin) {
    return true;
  }
  return false;
};

// Can have program write access
export const canWriteProgram = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.onboardingProgramAdminWrite) {
    return true;
  }
  return false;
};

// Can have kit read access
export const canReadKit = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.onboardingKitAdminRead || userFunctionAccess.onboardingKitAdminWrite || userFunctionAccess.onboardingKitApprover) {
    return true;
  }
  return false;
};

// Can have kit write access
export const canWriteKit = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.onboardingKitAdminWrite || userFunctionAccess.onboardingKitApprover) {
    return true;
  }
  return false;
};

// Can have sku read access
export const canReadSKU = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.skuAdminRead || userFunctionAccess.skuAdminWrite) {
    return true;
  }
  return false;
};

// Can have sku write access
export const canWriteSKU = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.skuAdminWrite) {
    return true;
  }
  return false;
};


// Can have preorder read access
export const canReadPreOrder = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.preOrderRead || userFunctionAccess.preOrderWrite) {
    return true;
  }
  return false;
};

// Can have preorder write access
export const canWritePreOrder = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.preOrderWrite) {
    return true;
  }
  return false;
};

// Can have device location read access
export const canReadDeviceLocation = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.deviceLocationRead || userFunctionAccess.deviceLocationWrite) {
    return true;
  }
  return false;
};

// Can have device location write access
export const canWriteDeviceLocation = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.deviceLocationWrite) {
    return true;
  }
  return false;
};

// Can view jobs
export const canJobRead = (jobName: string, userFunctionAccess: UserFunctionAccess) => {
  if (jobName.toLowerCase() === "enrollment" && (userFunctionAccess.enrollmentBatchAdminWrite || userFunctionAccess.enrollmentBatchAdminRead)) {
    return true;
  } else if (jobName.toLowerCase() === "new enrollment" && (userFunctionAccess.enrollmentBatchAdminWrite || userFunctionAccess.enrollmentBatchAdminRead)) {
    return true;
  } else if (jobName.toLowerCase() === "fulfillment" && (userFunctionAccess.fulfillmentBatchAdminWrite || userFunctionAccess.fulfillmentBatchAdminRead)) {
    return true;
  } else if (jobName.toLowerCase() === "crm" && (userFunctionAccess.crmBatchAdminWrite || userFunctionAccess.crmBatchAdminRead)) {
    return true;
  } else if (jobName.toLowerCase() === "status" && (userFunctionAccess.statusBatchAdminWrite || userFunctionAccess.statusBatchAdminRead)) {
    return true;
  } else if (jobName.toLowerCase() === "weather" && (userFunctionAccess.weatherBatchAdminWrite || userFunctionAccess.weatherBatchAdminRead)) {
    return true;
  } else if (jobName.toLowerCase() === "enrollmentfileprocess" && (userFunctionAccess.preEnrollmentBatchAdminWrite || userFunctionAccess.preEnrollmentBatchAdminRead)) {
    return true;
  }
  return false;
};

// Can update/trigger jobs
export const canJobWrite = (jobName: string, userFunctionAccess: UserFunctionAccess) => {
  if (jobName.toLowerCase() === "enrollment" && userFunctionAccess.enrollmentBatchAdminWrite) {
    return true;
  } else if (jobName.toLowerCase() === "Enrollment" && userFunctionAccess.enrollmentBatchAdminWrite) {
    return true;
  } else if (jobName.toLowerCase() === "new enrollment" && userFunctionAccess.enrollmentBatchAdminWrite) {
    return true;
  } else if (jobName.toLowerCase() === "fulfillment" && userFunctionAccess.fulfillmentBatchAdminWrite) {
    return true;
  } else if (jobName.toLowerCase() === "crm" && userFunctionAccess.crmBatchAdminWrite) {
    return true;
  } else if (jobName.toLowerCase() === "status" && userFunctionAccess.statusBatchAdminWrite) {
    return true;
  } else if (jobName.toLowerCase() === "weather" && userFunctionAccess.weatherBatchAdminWrite) {
    return true;
  } else if (jobName.toLowerCase() === "enrollmentfileprocess" && userFunctionAccess.preEnrollmentBatchAdminWrite) {
    return true;
  }
  return false;
};

// Can have enlistment read access
export const canReadEnlistment = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.enlistmentAdminRead || userFunctionAccess.enlistmentAdminWrite) {
    return true;
  }
  return false;
};

// Can have enlistment write access
export const canWriteEnlistment = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.enlistmentAdminWrite) {
    return true;
  }
  return false;
};

// Can have enrollment read access
export const canReadPendingEnrollment = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.pendingEnrollmentRead || userFunctionAccess.pendingEnrollmentWrite) {
    return true;
  }
  return false;
};

// Can have enrollment write access
export const canWritePendingEnrollment = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.pendingEnrollmentWrite) {
    return true;
  }
  return false;
};

// Can have enrollment file read access
export const canReadEnrollmentFile = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.preEnrollmentBatchAdminWrite || userFunctionAccess.preEnrollmentBatchAdminRead) {
    return true;
  }
  return false;
};

// Can have enrollment file write access
export const canWriteEnrollmentFile = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.preEnrollmentBatchAdminWrite) {
    return true;
  }
  return false;
};

// Can have status read access
export const canReadStatus = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.statusBatchAdminRead || userFunctionAccess.statusBatchAdminWrite) {
    return true;
  }
  return false;
};

// Can have status write access
export const canWriteStatus = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.statusBatchAdminWrite) {
    return true;
  }
  return false;
};

// Can have read saves
export const canReadSaves = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.savesRead || userFunctionAccess.savesWrite) {
    return true;
  }
  return false;
};

// Can have write saves
export const canWriteSaves = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.savesWrite) {
    return true;
  }
  return false;
};

// Can have read saves
export const canReadContractOrder = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.contractOrderRead || userFunctionAccess.contractOrderWrite) {
    return true;
  }
  return false;
};


// Can have write saves
export const canWriteContractOrder = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.contractOrderWrite) {
    return true;
  }
  return false;
};


// Can have read to account optout
export const canReadAccountOptout = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.accountOptoutRead || userFunctionAccess.accountOptoutWrite) {
    return true;
  }
  return false;
};


// Can have write to account optout
export const canWriteAccountOptout = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.accountOptoutWrite) {
    return true;
  }
  return false;
};


// Can submit manual order
export const canManualOrderSubmitter = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.manualOrderSubmitter || userFunctionAccess.manualOrderAdmin) {
    return true;
  }
  return false;
};

// Can approve manual order
export const canManualOrderAdmin = (userFunctionAccess: UserFunctionAccess) => {
  if (userFunctionAccess.manualOrderAdmin) {
    return true;
  }
  return false;
};
